import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b60148a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "pie-brochure" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "en-title" }, " PIE-Engine ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zh-title" }, " 遥感与地理信息云服务平台 ", -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"pie-service\" data-v-6b60148a><div class=\"pie-service-desc\" data-v-6b60148a></div></div><div class=\"num-desc\" data-v-6b60148a><div class=\"field-num\" data-v-6b60148a><div class=\"item\" data-v-6b60148a><span class=\"item-num\" data-v-6b60148a>60</span><span class=\"item-txt\" data-v-6b60148a>个行业,</span></div><div class=\"item\" data-v-6b60148a><span class=\"item-num\" data-v-6b60148a>400</span><span class=\"item-txt\" data-v-6b60148a>个客户,</span></div><div class=\"item\" data-v-6b60148a><span class=\"item-num\" data-v-6b60148a>7000+</span><span class=\"item-txt\" data-v-6b60148a>用户的选择</span></div></div><div class=\"features-desc\" data-v-6b60148a><div class=\"features-item\" data-v-6b60148a><div class=\"iconfont icon-outstanding\" data-v-6b60148a></div><div class=\"item-advantage\" data-v-6b60148a> 性能卓越 </div><div class=\"item-advantage-desc\" data-v-6b60148a> 利用云端弹性算力分布式完成您的计算请求 </div></div><div class=\"features-item\" data-v-6b60148a><div class=\"iconfont icon-easy-use\" data-v-6b60148a></div><div class=\"item-advantage\" data-v-6b60148a> 易于使用 </div><div class=\"item-advantage-desc\" data-v-6b60148a> 只需几行代码即可生成专题地图并嵌入到您的应用中 </div></div><div class=\"features-item\" data-v-6b60148a><div class=\"iconfont icon-safety-isolation\" data-v-6b60148a></div><div class=\"item-advantage\" data-v-6b60148a> 安全隔离 </div><div class=\"item-advantage-desc\" data-v-6b60148a> 将您的数据安全地托管在云端并与其他用户隔离 </div></div><div class=\"features-item\" data-v-6b60148a><div class=\"iconfont icon-mass-data\" data-v-6b60148a></div><div class=\"item-advantage\" data-v-6b60148a> 海量数据 </div><div class=\"item-advantage-desc\" data-v-6b60148a> 持续更新的PB级地理数据将为您的应用赋能 </div></div></div></div>", 2)

import { ref, } from 'vue';
import { useRouter, } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

// 了解详情按钮跳转
const jumpToPage = () => {
  window.open('https://engine.piesat.cn');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "pie-banner" }, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn-to-detail",
        onClick: jumpToPage
      }, " 了解详情 ")
    ]),
    _hoisted_4
  ]))
}
}

})